module.exports = __webpack_public_path__ + "static/img/shuziyingxiao_05.232b9bcc.jpg";